<template>
  <div class="confirmation-summary--property-details">
    <ConfirmationSummaryRow label="Occupied:">
      <span>{{isOccupiedOutput(model.propertyOccupied)}}</span>
    </ConfirmationSummaryRow>

    <ConfirmationSummaryRow label="Utilities On:">
      <span>{{utilitiesOnOutput(model)}}</span>
    </ConfirmationSummaryRow>

    <ConfirmationSummaryRow label="Year Built:">
      <span>{{model.yearBuilt || 'n/a'}}</span>
    </ConfirmationSummaryRow>

    <ConfirmationSummaryRow label="Square Footage:">
      <span>{{squareFootageOutput(model.squareFootage)}}</span>
    </ConfirmationSummaryRow>

    <ConfirmationSummaryRow label="Bedrooms:">
      <span>{{roomCountOutput(model.bedrooms)}}</span>
    </ConfirmationSummaryRow>

    <ConfirmationSummaryRow label="Bathrooms:">
      <span>{{roomCountOutput(model.bathrooms)}}</span>
    </ConfirmationSummaryRow>

    <ConfirmationSummaryRow label="Half-Bathrooms:">
      <span>{{roomCountOutput(model.halfBathrooms)}}</span>
    </ConfirmationSummaryRow>

    <ConfirmationSummaryRow label="MLS#:">
      <span>{{model.mls}}</span>
    </ConfirmationSummaryRow>
  </div>
</template>

<script>
import ConfirmationSummaryRow from '@/components/ConfirmationSummaryRow.vue';
import PropertyDetailsMixin from '@/mixins/PropertyDetailsMixin';

export default {
  components: {
    ConfirmationSummaryRow,
  },
  mixins: [PropertyDetailsMixin],
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
};
</script>
